

import React, { useState, useEffect } from "react";

import Table from "../Table/Table";

import api from "../../api/baseUrl";



export default function InvoiceMraketer({
  // orders, visitors, sellers, products,
  // refreshDataProducts, refreshDataSeller, refreshDataInvoices

}) {
  const [orders, setOrders] = useState(); // ← اضافه شد

  const [visitors, setVisitors] = useState(); // ← اضافه شد
  const [sellers, setSellers] = useState(); // ← اضافه شد
  const [products, setProducts] = useState(); // ← اضافه شد
  const [getDataAllInvoice, setGetDataAllInvoice] = useState(null);




  const handleFetchMarketers = async () => {

    try {



      const response = await api.get("/get-marketers");
      setVisitors(response.data.messages)




    } catch (err) {
      console.error("Login Error:", err.response?.data || err.message);
      // setSnackbar({ message: "خطا در ورود!", type: "error" });
    } finally {
      // setLoading(false);
    }
  };


  const handleFetchSellers = async () => {

    try {



      const response = await api.get("/get-sellers");
      // setVisitors(response.data.messages)

      setSellers(response.data.messages)




    } catch (err) {
      console.error("Login Error:", err.response?.data || err.message);
      // setSnackbar({ message: "خطا در ورود!", type: "error" });
    } finally {
      // setLoading(false);
    }
  };


  const handleFetchProducts = async () => {

    try {



      const response = await api.get("/get-products");
      // setVisitors(response.data.messages)
      console.log("Get products", response.data.messages);

      setProducts(response.data.messages)




    } catch (err) {
      console.error("Login Error:", err.response?.data || err.message);
      // setSnackbar({ message: "خطا در ورود!", type: "error" });
    } finally {
      // setLoading(false);
    }
  };



  const handleFetchInvoices = async () => {

    try {



      const response = await api.get("/get-invoices");
      console.log("Get invoices", response.data.messages);

      // setProducts(response.data.messages)

      setOrders(response.data.messages)


    } catch (err) {
      console.error("Login Error:", err.response?.data || err.message);
      // setSnackbar({ message: "خطا در ورود!", type: "error" });
    } finally {
      // setLoading(false);
    }
  };


  const handleGetDataAllInvoice = async () => {
    try {
      const result = await api.post("/crud-invoices", { action: "get", invoice_id: 1235794530 });

      setGetDataAllInvoice(result.data)

      if (result.data.accepted && result.data.message) {
        // setInvoiceDetails(result.data.message[0]); // فرض بر این است که سرور object فاکتور را برمی‌گرداند
        // setShowInvoiceModal(true);


      } else {
        alert("اطلاعات فاکتور یافت نشد");
      }
    } catch (error) {
      console.error("خطا در دریافت فاکتور:", error);
      alert("خطا در دریافت اطلاعات فاکتور");
    }
  };



  useEffect(() => {
 handleFetchMarketers()
 handleFetchProducts()
 handleFetchSellers()
 handleFetchInvoices()
  }, []);


  return (
    <div id="ordersPage">
      <section className="card">
        <Table
          title="سفارشات"
          searchPlaceholder="جستجوی سفارش..."
          orders={orders}
          visitors={visitors}
          sellers={sellers}
          products={products}
          refreshDataProducts={handleFetchProducts}
          refreshDataSeller={handleFetchSellers}
          refreshDataInvoices={handleGetDataAllInvoice}
            showExportButton={false} // ❌ دکمه غیرفعال می‌شود
  showAddSellerButton={true} // ✅ فقط در جاهایی که لازم است true

        />
      </section>
    </div>
  );
}
